import { render, staticRenderFns } from "./HeaderC.vue?vue&type=template&id=927866ca&scoped=true&"
import script from "./HeaderC.vue?vue&type=script&lang=ts&"
export * from "./HeaderC.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderC.vue?vue&type=style&index=0&id=927866ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927866ca",
  null
  
)

export default component.exports